<template>
  <div v-if="activity !== null && activity !== undefined && activity.quest !== undefined"
       class="row justify-content-center activity-detail">

    <ActivityCountdown v-show="showCountdownView" :open="showCountdownView"></ActivityCountdown>

    <div v-if="planned || !(activity.quest.format === 'quiz')" class="description-box-wrapper">

      <div class="info-window">
        <div class="header"></div>
        <div class="info-content">

          <!--Quest media item-->
          <div class="row image mt-3"
               v-if="activity.quest.mediaItem && activity.quest.mediaItem.type !== mediaItemTypeEnum.none">
            <div class="col">
              <div class="activity-image"
                   v-if="activity.quest.mediaItem.type === mediaItemTypeEnum.image && activity.quest.mediaItem.imageAsset">
                <img class="img-fluid" :src="activity.quest.mediaItem.imageAsset.url" alt="Activiteit afbeelding"/>
              </div>
              <div class="embed-responsive embed-responsive-16by9 activity-video"
                   v-if="activity.quest.mediaItem.type === mediaItemTypeEnum.video && activity.quest.mediaItem.videoUrl">
                <iframe class="embed-responsive-item"
                        :src="convertYoutubeUrlToEmbedUrl(activity.quest.mediaItem.videoUrl)"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>
              </div>
            </div>
          </div>

          <div class="description">
            <p v-if="planned">{{ activity.quest.descriptionTeacher }}</p>
            <p v-if="!planned">{{ activity.quest.descriptionStudent }}</p>

            <div v-if="activity.quest.format === 'quiz'">
              <div :key="question" v-for="question in activity.quest.quizQuestions">
                <p>{{ question.phrase }}</p>
              </div>
            </div>

            <h2 v-if="!planned && activity?.quest?.questResults?.length > 0" class="results-title">RESULTATEN</h2>
            <div v-if="!planned" class="result-inputs">
              <div v-for="result in activity.quest.questResults" :key="result.id" class="result-input-wrapper">
                <div v-if="result.format === 'text'" class="text-input-wrapper">
                  <p>{{ result.label }}</p>
                  <input type="text" class="result-input text-input" placeholder="" :data-id="result.id"
                         :data-format="result.format" :data-label="result.label">
                </div>
              </div>
            </div>

          </div>
          <div class="to-earn-batteries">
            <p class="d-flex align-items-center justify-content-center">
              Te verdienen energie:
              <span :key="battery" class="colorable-icon points-icon" v-for="battery in activity.quest.points"></span>
            </p>
          </div>
        </div>

        <div class="footer"></div>

        <WhiteOutlineButton v-if="planned" class="start-planned-activity-button" :button-text="getStartButtonText"
                            v-on:clicked="startActivityClicked"></WhiteOutlineButton>

        <WhiteOutlineButton v-if="!planned && activity.quest.format === 'puzzle'" class="start-planned-activity-button"
                            :button-text="'TOON PUZZEL'"
                            v-on:clicked="showPuzzle"></WhiteOutlineButton>

        <WhiteOutlineButton v-if="!planned" class="start-planned-activity-button" button-text="ACTIVITEIT AFRONDEN"
                            v-on:clicked="completeActivityClicked"></WhiteOutlineButton>

        <button class="btn cancel-activity-button" v-on:click="cancelActivityClicked">Activiteit annuleren</button>


      </div>
    </div>

    <!-- placeholder for buddy phone view -->
    <div class="buddy-phone-view" v-if="!planned">
      <img src="~@/assets/image/platform/frame_camerafeed.svg" alt="">
      <div class="buddy-content">
        <ActivityDetailBuddy v-if="buddy.id !== null" :buddy="buddy"></ActivityDetailBuddy>
        <div class="buddy-background"></div>
      </div>
    </div>

    <Quiz v-if="(activity.quest.format === 'quiz') && !planned" :quizQuestions="activity.quest.quizQuestions"
          :activity="activity" @completeActivityClicked="completeActivityClicked"
          @cancelActivityClicked="cancelActivityClicked"></Quiz>

    <CancelActivityPopup v-if="showCancelActivityPopup" :open="showCancelActivityPopup"
                         @closeClicked="showCancelActivityPopup = false"
                         @confirmClicked="cancelActivityConfirmed"></CancelActivityPopup>

  </div>
</template>

<script>

import { QuestMediaTypeEnum, QuestFormatEnum, QuestTypeEnum } from "sandpiper_api";
import YoutubeVideoEmbedder from "@/mixins/YoutubeVideoEmbedder";

import QuestPropertiesHelper from "@/mixins/QuestPropertiesHelper";
import WhiteOutlineButton from "@/components/StudentPlatform/WhiteOutlineButton";
import ActivityCountdown from "@/components/StudentPlatform/Activities/ActivityCountdown";
import Quiz from "@/components/StudentPlatform/Activities/Quiz";
import CancelActivityPopup from "@/components/StudentPlatform/Activities/CancelActivityPopup";
import ActivityDetailBuddy from "@/components/StudentPlatform/Activities/ActivityDetailBuddy.vue";


export default {
  name: "PlannedActivity",
  components: {ActivityDetailBuddy, WhiteOutlineButton, ActivityCountdown, Quiz, CancelActivityPopup},
  emits: [ "startActivityClicked", "completeActivityClicked", "cancelActivityClicked" ],
  props: {
    name: String,
    open: Boolean,
    //activityId: Number,
    activity: Object,
    buddy: Object,
  },
  mixins: [ QuestPropertiesHelper, YoutubeVideoEmbedder ],
  inject: [ "doApiRequest" ],
  watch: {
    open: {
      handler()
      {
        console.log("[PA] open changed");
        console.log(this.activity);
        //this is silly. This will filter on activities that haven't started and aren't planned, and start them. 
        if (this.open && this.activity.quest && !this.activity.startedDate && !this.activity.plannedDate) {
          //this activity is not a planned one. Start it automatically
          //  this.startActivityClicked();
        }
        if (this.open && this.activityId !== null && this.activityId !== undefined)
        {
          console.log("opening");
        }
        else
        {
          console.log("closing");
        }
      },
      deep: true,
    },
    activity: {
      handler() {
        console.log("[PA] activity changed");
        console.log(this.activity);
        //this is silly. This will filter on activities that haven't started and aren't planned, and start them. 
        if (this.open && this.activity && !this.activity.startedDate) {
          //this activity is not a planned one. Start it automatically
          this.startActivityClicked();
        }
      },
      deep: true,
    }
  },
  data()
  {
    return {
      mediaItemTypeEnum: new QuestMediaTypeEnum(),
      questFormatEnum: new QuestFormatEnum(),
      questTypeEnum: new QuestTypeEnum(),
      showCountdownView: false,
      showCancelActivityPopup: false,

    }
  },
  computed: {
    planned()
    {
      return this.activity.startedDate == null;
    },
    getStartButtonText()
    {
      let text = "";
      if (this.activity.quest.format === "puzzle")
      {
        text = "PUZZEL STARTEN";
      }
      else if (this.activity.quest.format === "quiz")
      {
        text = "QUIZ STARTEN";
      }
      else
      {
        text = "ACTIVITEIT STARTEN";
      }
      return text;
    }
  },
  methods: {

    startActivityClicked()
    {
      console.log("[PA startActivityClicked emitted from PlannedActivity]")
      console.log(this.activity);
      this.$emit("startActivityClicked", {id: this.activity.id, questTypeName: this.activity.quest.type});
      
      if (this.activity.quest.format === "puzzle")
      {
        window.open(this.activity.quest.puzzle.embedUrl, "_blank");
      }

    },

    showCountdown()
    {
      this.$emit("startActivityClicked", {id: this.activity.id, questTypeName: this.activity.quest.type});
      /*
      this.showCountdownView = true;

      setTimeout(() =>
      {
        this.$emit("startActivityClicked", { id: this.activity.id, questTypeName: this.activity.quest.type });
        this.showCountdownView = false;
      }, 4000);
*/
    },

    showPuzzle()
    {
      window.open(this.activity.quest.puzzle.embedUrl, "_blank");
    },

    completeActivityClicked()
    {
      let data = {
        activityId: this.activity.id,
        results: this.getResults(),
      };
      this.$emit("completeActivityClicked", data);
    },

    cancelActivityClicked()
    {
      this.showCancelActivityPopup = true;
    },

    cancelActivityConfirmed()
    {
      this.showCancelActivityPopup = false;
      this.$emit("cancelActivityClicked", this.activity.id);

    },

    getResults()
    {
      let results = [];
      document.querySelectorAll('.result-input').forEach(resultEl =>
      {
        let result = {
          format: resultEl.dataset.format,
          resultValue: resultEl.value,
          label: resultEl.dataset.label,
        };
        results.push(result);
      });

      return results;
    },

    addCommaIfNecessary(array, index, value)
    {
      if (index !== array.length - 1)
      {
        return value + `, `;
      }
      else
      {
        return value;
      }
    }
  },
  mounted() {
    
  }
}
</script>

<style lang="scss" scoped>

::-webkit-scrollbar {
  display: none;
}

.top-bar {
  margin: 0 2rem;
  margin-top: 7rem;
  height: 50px;
  display: flex;
  justify-content: space-between;

  p {
    font-weight: bold;
    font-size: 2rem;
    color: white;
  }
}

.info-window {

  position: relative;

  .header {
    background-image: url("~@/assets/image/platform/frame/frame_medium_top.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: bottom center;
    height: min(5vw, 11vh);
    top: 1px;
    position: relative;
  }

  .info-content {
    background-image: url("~@/assets/image/platform/frame/frame_medium_mid.svg");
    background-size: 100%;
    background-position: center center;
    position: relative;
    padding: 25px;

  }

  .footer {
    background-image: url("~@/assets/image/platform/frame/frame_medium_bot.svg");
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: top center;
    height: min(5vw, 11vh);
  }

  .pips {
    display: flex;
    justify-content: center;
    align-items: center;

    .pip {
      width: 10px;
      height: 10px;
      padding: 0px;
      border-radius: 10px;
      background-color: white;
      margin: 5px;

      &.large {
        width: 15px;
        height: 15px;
      }
    }
  }
}

.activity-detail {
  padding-top: 6%;
  margin: 0 2rem;
  margin-bottom: 2rem;
  height: 100%;
  overflow-y: scroll;
}

.activity-list {
  margin: 0 2rem;
  margin-top: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 1rem;
  overflow: overlay;

}

.description-box {
  width: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
}

.start-activity-button {
  margin-bottom: 30px;
}

.cancel-activity-button {
  text-decoration: underline;
  color: white;
  margin: 0 auto;
  display: block;
  margin-bottom: 50px;
}

.description-box-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  flex: 0 0 60%;
  max-width: 900px;
}


.description {
  width: 100%;
  height: 50%;
  overflow-y: scroll;
  margin: 30px 0;
  font-size: 1.3rem;

  p {
    margin-top: 15px;
    color: white;
    white-space: pre-line;

  }
}


.start-planned-activity-button {
  //min-width: 350px;
  //width: 50%;
  //height: 60px;
  margin: 0 auto;
  margin-top: 2rem;
}

.to-earn-batteries {
  width: 80%;
  height: 100px;
  position: absolute;
  //bottom: 48px;
  left: 10%;
  background-image: url("~@/assets/image/bb_frame-title.svg");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2%;

  p {
    color: white;
    font-weight: bold;
    font-size: 1.1rem;
    margin-bottom: 0;

    span {
      width: 35px;
      height: 60px;
    }
  }
}

//results

.results-title {
  color: white;
  margin: 30px 0;
}

.text-input-wrapper {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  p {
    margin: 0 5px;
  }

  input {
    font-weight: bold;
  }
}

.image {
  justify-content: center;
}

.activity-image {
  display: flex;
  justify-content: center;
}

.buddy-phone-view {
  //width: 300px;
  //height: 100%;
  width: 274px;
  height: 338px;
  //background-color: red;
  padding: 12px;
  position: relative;

  img {
    position: relative;
    width: 100%;
    z-index: 3;
  }

  .buddy-content {
    width: 250px;
    //height: 100%;
    height: 308px;
    position: absolute;
    top: 0;
    //clip-path: polygon(2% 6.8%, 90% 6.8%, 90% 45%, 2% 45%);
    clip-path: polygon(6px 42px, 281px 42px, 281px 289px, 6px 289px);
    z-index: 0;
  }
  
  .buddy-background {
    width: 100%;
    height: 100%;
    background-image: url("~@/assets/image/platform/background/bb_background.svg");
    background-position: bottom center;
    background-repeat: no-repeat;
    background-size: cover;
    z-index: -1;
  }
}

</style>